// In the DMS document drawer: the urbanism dossier of a registered request (chip), or "open a dossier" for a request that came on
// paper without the official form (the procedure is chosen; the document stays the dossier's request).
import React, { useEffect, useState } from 'react';
import { api } from '../api';
import { navigate, useAuth } from '../store';
import { Field, Modal, useToast } from '../ui';
import { Icon } from '../ui/Icon';
import type { UDossier } from './types';
import { urbChanged, useProcedures } from './types';
import { hasUrbanism } from './Urbanism';

export function UrbDocButton({ doc }: { doc: { id: number; moduleRef?: string | null; direction?: string } }) {
  const { user } = useAuth();
  const toast = useToast();
  const allowed = hasUrbanism(user!.roles);
  const [d, setD] = useState<UDossier | null | undefined>(undefined);
  const [open, setOpen] = useState(false);
  const [proc, setProc] = useState('CU_CONSTRUIRE');
  const procs = useProcedures();
  useEffect(() => { if (allowed) api.get<UDossier>('/api/urbanism/by-document/' + doc.id).then(x => setD(x && x.id ? x : null)).catch(() => setD(undefined)); }, [doc.id, allowed]);
  if (!allowed || d === undefined) return null;
  if (d) return <button className="alop-chip" title={`Dosar de urbanism: ${d.procedureName} — ${d.statusLabel}`} onClick={() => navigate('/urbanism/dossier/' + d.id)}><Icon name="building" size={13} />{d.procedureShort || 'Urbanism'} · {d.statusLabel}</button>;
  if (doc.moduleRef) return null;
  const create = async () => {
    try { const x = await api.post<UDossier>('/api/urbanism/from-document/' + doc.id, { procedure: proc }); urbChanged(); toast('Dosarul de urbanism a fost deschis', 'ok'); navigate('/urbanism/dossier/' + x.id); }
    catch (e: any) { toast(e.message, 'error'); }
  };
  return <>
    <button className="btn sm" onClick={() => setOpen(true)} title="Deschide un dosar de urbanism pentru această cerere"><Icon name="building" />Urbanism</button>
    {open && <Modal title="Dosar de urbanism din acest document" icon="building" size="sm" onClose={() => setOpen(false)}
      footer={<><span className="grow" /><button className="btn" onClick={() => setOpen(false)}>Renunță</button><button className="btn primary" onClick={create}>Deschide dosarul</button></>}>
      <div className="stack">
        <p className="muted small" style={{ margin: 0 }}>Documentul rămâne cererea dosarului (numărul și termenul din registru). Formularul oficial se poate completa ulterior în dosar.</p>
        <Field label="Procedura"><select className="select" value={proc} onChange={e => setProc(e.target.value)}>{procs?.procedures.filter(p => !['INCEPERE', 'INCHEIERE', 'NOT_FINALIZARE'].includes(p.code)).map(p => <option key={p.code} value={p.code}>{p.name}</option>)}</select></Field>
      </div>
    </Modal>}
  </>;
}
